module.exports = __webpack_public_path__ + "static/media/batchPositionAuthStateImportTemp.9e881075.xlsx";